'use client';

import alternativePrimaryItemSelectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/AlternativePrimaryItem/selectEnergyLabelInformationTrigger';
import alternativePrimaryItemShowEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/AlternativePrimaryItem/showEnergyLabelTrigger';
import orderBlockSelectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/selectEnergyLabelInformationTrigger';
import orderBlockShowEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/OrderBlock/showEnergyLabelTrigger';
import orderBlockSummarySelectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/selectEnergyLabelInformationTrigger';
import orderBlockSummaryShowEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/OrderBlockSummary/showEnergyLabelTrigger';
import outOfStockEntranceSelectEnergyLabelInformationTrigger from '@coolblue-development/ga4-events/triggers/OutOfStockEntrance/selectEnergyLabelInformationTrigger';
import outOfStockEntranceShowEnergyLabelTrigger from '@coolblue-development/ga4-events/triggers/OutOfStockEntrance/showEnergyLabelTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import EnergyLabelComponent, {
  type EnergyLabelProps
} from '@coolblue-development/next-energy-label/client';
import type { EnergyLabelType } from '@features/product/typings';

import { trackingFeatureNameType } from './EnergyLabel.types';

export const EnergyLabel = ({
  energyLabel,
  trackingFeatureName = 'order_block',
  direction,
  size,
  bypassSubsidiaryCheck = false
}: {
  energyLabel: EnergyLabelType;
  trackingFeatureName: trackingFeatureNameType;
  direction?: EnergyLabelProps['direction'];
  size?: EnergyLabelProps['size'];
  bypassSubsidiaryCheck?: boolean;
}) => {
  const { trackEvent } = useAnalytics();

  if (!energyLabel) return <></>;

  const showTriggerEvents = {
    alternative_primary_item: alternativePrimaryItemShowEnergyLabelTrigger,
    order_block: orderBlockShowEnergyLabelTrigger,
    order_block_summary: orderBlockSummaryShowEnergyLabelTrigger,
    out_of_stock_entrance: outOfStockEntranceShowEnergyLabelTrigger
  };

  const clickTriggerEvents = {
    alternative_primary_item: alternativePrimaryItemSelectEnergyLabelInformationTrigger,
    order_block: orderBlockSelectEnergyLabelInformationTrigger,
    order_block_summary: orderBlockSummarySelectEnergyLabelInformationTrigger,
    out_of_stock_entrance: outOfStockEntranceSelectEnergyLabelInformationTrigger
  };

  const onShow = () => {
    if (trackingFeatureName) {
      trackEvent(showTriggerEvents[trackingFeatureName]());
    }
  };

  const onContentClick = () => {
    if (trackingFeatureName) {
      trackEvent(
        clickTriggerEvents[trackingFeatureName]({
          content: 'product_information_sheet'
        })
      );
    }
  };

  return (
    <EnergyLabelComponent
      direction={direction}
      size={size}
      onContentClick={onContentClick}
      onShow={onShow}
      level={Number(energyLabel.level)}
      version={energyLabel.version || undefined}
      bypassSubsidiaryCheck={bypassSubsidiaryCheck}
      {...(energyLabel.image?.id && { imageId: Number(energyLabel.image.id) })}
      {...(energyLabel.specification?.absoluteUrl && {
        specificationUrl: energyLabel.specification.absoluteUrl
      })}
    />
  );
};
